import { Box, Checkbox, ListItemIcon, Typography } from '@mui/material'

interface Props {
  renderProps: any
  name: string
  isSelected?: boolean
  showCheckbox?: boolean
}
export const YardBlockOption = ({ renderProps, name, isSelected, showCheckbox }: Props) => {
  return (
    <Box {...renderProps} component='li' data-cy={`yard-block-option-${name}`}>
      {showCheckbox && (
        <ListItemIcon>
          <Checkbox edge='start' checked={isSelected} disableRipple />
        </ListItemIcon>
      )}
      <Typography variant='body1'>{name}</Typography>
    </Box>
  )
}
